import { Stack, Typography } from "@mui/material";
import i18n from "../../../../../i18n";
import { CalendarIcon } from "../assets";
import styles from "./DataBar.module.css";

type DataBarProps = {
	candidateName: string;
	positionName: string;
	startTime?: Date;
};

function formatDate(dateInput: Date | string | number): string {
	const date = new Date(dateInput);
	const now = new Date();

	const isSameDay = (a: Date, b: Date) =>
		a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

	const yesterday = new Date();
	yesterday.setDate(now.getDate() - 1);

	let prefix = "";

	if (isSameDay(date, now)) {
		prefix = i18n.t("candidate.resultsPage.unattended.header.date.today");
	} else if (isSameDay(date, yesterday)) {
		prefix = i18n.t("candidate.resultsPage.unattended.header.date.yesterday");
	}

	const datePart = date.toLocaleDateString("en-US", {
		...(prefix ? {} : { weekday: "long" }),
		month: "long",
		day: "numeric",
		year: "numeric",
	});

	const timePart = date.toLocaleTimeString("en-US", {
		hour: "2-digit",
		minute: "2-digit",
		hour12: true,
	});

	return prefix ? `${prefix}, ${datePart} at ${timePart}` : `${datePart} at ${timePart}`;
}

export default function DataBar({ candidateName, positionName, startTime }: DataBarProps) {
	return (
		<div className={styles.dataBar}>
			<Stack direction="row" gap="16px">
				<Typography>
					<span className={styles.label}>{i18n.t("candidate.resultsPage.unattended.header.candidate")}</span>{" "}
					<span className={styles.value}>{candidateName}</span>
				</Typography>
				<div className={styles.divider} />
				<Typography>
					<span className={styles.label}>{i18n.t("candidate.resultsPage.unattended.header.position")}</span>{" "}
					<span className={styles.value}>{positionName}</span>
				</Typography>
				<div className={styles.divider} />
				<Stack direction="row" gap="4px" alignItems="center">
					<CalendarIcon />
					<Typography className={styles.value}>
						{startTime ? formatDate(startTime) : i18n.t("candidate.resultsPage.unattended.header.date.invalid")}
					</Typography>
				</Stack>
			</Stack>
		</div>
	);
}
